export default $wire => ({
    loading: false,

    submit: function () {
        this.loading = true;

        $wire.dispatchSelf('searchByLocation');
    },
});
